import { render } from "../../templates/instrumentPage/my-offers.html?vue&type=template&id=3b2eaf98"
import script from "./my-offers.vue?vue&type=script&lang=js"
export * from "./my-offers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__